<template>
    <div id="emerge-detail">
        <!--=====================================-->
        <!--=      Case Study  Area Start       =-->
        <!--=====================================-->
        <section class="section mb--80">
            <div class="container">
                <div class="section-heading heading-light-left mb-0">
                    <span class="subtitle emerge-red bold">¿Qué es EMERGE?</span>
                </div>
                <div class="row">
                    <div class="col-sm-12 col-md-8 col-lg-6">
                        <h2 class="font-weight-100">Juntos <span class="bold">democratizamos</span> las energías limpias.</h2>
                        <p class="black body-font-1">
                            El proyecto EMERGE (Empresas Minoristas con Energía Renovable
                            y Generación Eléctrica) busca crear un cambio positivo en nuestra sociedad
                            y nuestro planeta facilitando el acceso de micro, pequeñas y medianas
                            empresas del sector comercial minorista a financiamiento para que instalen
                            sistemas solares en sus negocios, generando ahorros económicos
                            que contribuyan a la recuperación verde y reduciendo la emisión de gases
                            de efecto invernadero asociados a su operación.
                            <br><br>
                            EMERGE es una cooperación de desarrollo entre la empresa Coca-Cola
                            FEMSA, RedGirasol y la Cooperación Alemana para el Desarrollo Sustentable
                            (GIZ) en México. Se implementa a través del programa develoPPP
                            por encargo del Ministerio Federal de Cooperación Económica
                            y Desarrollo de Alemania (BMZ) a la GIZ. 
                        </p>
                    </div>
                    <div class="col-sm-12 col-md-4 col-lg-6">
                        <div class="text-align-center">
                            <img class="w-75 emerge-img" src="https://cdn.redgirasol.com/nuevo_portal/emerge/logos/logo-emerge-rg.png" alt="emerge-rg">
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        name: "EmergeInfo"
    }
</script>

<style>

.emerge-img {
    filter: opacity(0.8);
}

.emerge-img:hover {
    filter: opacity(1);
    transition: var(--transition);
}

</style>